import { source } from "common-tags";
import { pascalCase } from "../lib/pascalCase.js";
var __freeze = Object.freeze;
var __defProp = Object.defineProperty;
var __template = (cooked, raw) => __freeze(__defProp(cooked, "raw", { value: __freeze(cooked.slice()) }));
var _a, _b, _c, _d;
const PLACEHOLDER = `
Placeholder component for {slice.slice_type} (variation: {slice.variation}) slices.
<br />
<strong>You can edit this slice directly in your code editor.</strong>
<!--
💡 Use the Prismic MCP server with your code editor
📚 Docs: https://prismic.io/docs/ai#code-with-prismics-mcp-server
-->
`;
function sliceTemplate(args) {
  const { model, typescript, version } = args;
  const pascalName = pascalCase(model.name);
  const v5TS = source(_a || (_a = __template([`
		<script lang="ts">
			import type { Content } from '@prismicio/client';
			import type { SliceComponentProps } from '@prismicio/svelte';

			type Props = SliceComponentProps<Content.`, "Slice>;\n\n			const { slice }: Props = $props();\n		<\/script>\n\n		<section data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>\n			", "\n		</section>\n	"])), pascalName, PLACEHOLDER);
  const v5JS = source(_b || (_b = __template(['\n		<script>\n			/* @typedef {import("@prismicio/client").Content} Content */\n			/* @typedef {import("@prismicio/svelte").SliceComponentProps} SliceComponentProps */\n\n			/* @type {SliceComponentProps<Content.', "Slice>} */\n			const { slice } = $props();\n		<\/script>\n\n		<section data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>\n			", "\n		</section>\n	"])), pascalName, PLACEHOLDER);
  const v4TS = source(_c || (_c = __template([`
		<script lang="ts">
			import type { Content } from '@prismicio/client';

			export let slice: Content.`, "Slice;\n		<\/script>\n\n		<section data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>\n			", "\n		</section>\n	"])), pascalName, PLACEHOLDER);
  const v4JS = source(_d || (_d = __template(['\n		<script>\n			/** @type {import("@prismicio/client").Content.', "Slice} */\n			export let slice;\n		<\/script>\n\n		<section data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>\n			", "\n		</section>\n	"])), pascalName, PLACEHOLDER);
  if (typescript) {
    return version <= 4 ? v4TS : v5TS;
  }
  return version <= 4 ? v4JS : v5JS;
}
export {
  sliceTemplate
};
//# sourceMappingURL=slice-create.templates.js.map
